'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = userAuthMiddleware;

var _constants = require('redux/constants');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function userAuthMiddleware(ibonus) {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;
        return function (next) {
            return function (action) {
                if (action.type) {
                    switch (action.type) {
                        // при успешном восстановлении пароля, сохраним токены в localStorage
                        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS:
                            {
                                if (action.result && action.result.access_token && action.result.refresh_token && __CLIENT__) {
                                    _LocalStorageProxy2.default.setItem('ibonus.access_token', action.result.access_token);
                                    _LocalStorageProxy2.default.setItem('ibonus.refresh_token', action.result.refresh_token);
                                }

                                break;
                            }

                        case _constants.AuthConstants.LOGIN_SUCCESS:
                            {
                                if (action.result && action.result.access_token && action.result.refresh_token && __CLIENT__) {
                                    _LocalStorageProxy2.default.setItem('ibonus.access_token', action.result.access_token);
                                    _LocalStorageProxy2.default.setItem('ibonus.refresh_token', action.result.refresh_token);
                                    var wishList = _LocalStorageProxy2.default.getItem('wishlist.common');
                                    ibonus.getWishList(wishList).then(function (result) {
                                        _LocalStorageProxy2.default.setItem('wishlist.common', result);
                                    });
                                    return ibonus.getUserData(action.result.access_token).then(function (result) {
                                        return next({ result: result, type: _constants.AuthConstants.LOGIN_SUCCESS });
                                    }, function (error) {
                                        return next({ error: error, type: _constants.AuthConstants.LOGIN_FAIL });
                                    }).catch(function (error) {
                                        next({ error: error, type: _constants.AuthConstants.LOGIN_FAIL });
                                    });
                                }

                                break;
                            }

                        case _constants.AuthConstants.LOGOUT_SUCCESS:
                            {
                                _LocalStorageProxy2.default.removeItem('ibonus.access_token');
                                _LocalStorageProxy2.default.removeItem('ibonus.refresh_token');
                                break;
                            }
                    }
                }
                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/userAuthMiddleware.js
// module id = 1892
// module chunks = 0